"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_request_client_1 = require("../graphql-request-client");

var constants_1 = require("../constants");

var dictionary_service_1 = require("./dictionary-service");

var graphql_1 = require("../graphql");

var debug_1 = __importDefault(require("../debug"));
/** @private */


exports.queryError = 'Valid value for rootItemId not provided and failed to auto-resolve app root item.';
var query =
/* GraphQL */
"\n  query DictionarySearch(\n    $rootItemId: String!\n    $language: String!\n    $templates: String!\n    $pageSize: Int = 10\n    $after: String\n  ) {\n    search(\n      where: {\n        AND: [\n          { name: \"_path\", value: $rootItemId, operator: CONTAINS }\n          { name: \"_language\", value: $language }\n          { name: \"_templates\", value: $templates, operator: CONTAINS }\n        ]\n      }\n      first: $pageSize\n      after: $after\n    ) {\n      total\n      pageInfo {\n        endCursor\n        hasNext\n      }\n      results {\n        key: field(name: \"Key\") {\n          value\n        }\n        phrase: field(name: \"Phrase\") {\n          value\n        }\n      }\n    }\n  }\n";
/**
 * Service that fetch dictionary data using Sitecore's GraphQL API.
 * @augments DictionaryServiceBase
 * @mixes SearchQueryService<DictionaryQueryResult>
 */

var GraphQLDictionaryService =
/** @class */
function (_super) {
  __extends(GraphQLDictionaryService, _super);
  /**
   * Creates an instance of graphQL dictionary service with the provided options
   * @param {GraphQLDictionaryService} options instance
   */


  function GraphQLDictionaryService(options) {
    var _this = _super.call(this, options) || this;

    _this.options = options;
    _this.graphQLClient = _this.getGraphQLClient();
    _this.searchService = new graphql_1.SearchQueryService(_this.graphQLClient);
    return _this;
  }
  /**
   * Fetches dictionary data for internalization.
   * @param {string} language the language to fetch
   * @default query (@see query)
   * @returns dictionary phrases
   * @throws {Error} if the app root was not found for the specified site and language.
   */


  GraphQLDictionaryService.prototype.fetchDictionaryData = function (language) {
    return __awaiter(this, void 0, void 0, function () {
      var cacheKey, cachedValue, rootItemId, _a, phrases;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            cacheKey = this.options.siteName + language;
            cachedValue = this.getCacheValue(cacheKey);

            if (cachedValue) {
              debug_1.default.dictionary('using cached dictionary data for %s %s', language, this.options.siteName);
              return [2
              /*return*/
              , cachedValue];
            }

            _a = this.options.rootItemId;
            if (_a) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , graphql_1.getAppRootId(this.graphQLClient, this.options.siteName, language)];

          case 1:
            _a = _b.sent();
            _b.label = 2;

          case 2:
            rootItemId = _a;

            if (!rootItemId) {
              throw new Error(exports.queryError);
            }

            debug_1.default.dictionary('fetching dictionary data for %s %s', language, this.options.siteName);
            phrases = {};
            return [4
            /*yield*/
            , this.searchService.fetch(query, {
              rootItemId: rootItemId,
              language: language,
              templates: this.options.dictionaryEntryTemplateId || constants_1.SitecoreTemplateId.DictionaryEntry,
              pageSize: this.options.pageSize
            }).then(function (results) {
              results.forEach(function (item) {
                return phrases[item.key.value] = item.phrase.value;
              });
            })];

          case 3:
            _b.sent();

            this.setCacheValue(cacheKey, phrases);
            return [2
            /*return*/
            , phrases];
        }
      });
    });
  };
  /**
   * Gets a GraphQL client that can make requests to the API. Uses graphql-request as the default
   * library for fetching graphql data (@see GraphQLRequestClient). Override this method if you
   * want to use something else.
   * @returns {GraphQLClient} implementation
   */


  GraphQLDictionaryService.prototype.getGraphQLClient = function () {
    return new graphql_request_client_1.GraphQLRequestClient(this.options.endpoint, {
      apiKey: this.options.apiKey,
      debugger: debug_1.default.dictionary
    });
  };

  return GraphQLDictionaryService;
}(dictionary_service_1.DictionaryServiceBase);

exports.GraphQLDictionaryService = GraphQLDictionaryService;